/* eslint-disable prettier/prettier */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {
  DefaultInputStyled,
  Wrapper,
  InputButtonStyled,
  StyledButton,
  StyledInput,
} from "./styles/DefaultInputStyled";

class DefaultInput extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      filteredValue: props.defaultValue,
    };
    this.inputElement = null;
    this.value = props.defaultValue;
  }

  componentDidMount() {
    const { onChange } = this.props;
    if (this.value) {
      onChange({
        inputElement: this.inputElement,
        value: this.value,
      });
    }
  }

  onFocusChange = (event) => {
    const focused = event.type === "focus";
    const { onFocusChange } = this.props;
    this.setState({
      focused,
    });

    if (_.isFunction(onFocusChange)) {
      onFocusChange({
        focused,
        inputElement: this.inputElement,
        value: this.value,
      });
    }
  };

  onChange = (event) => {
    const { onChange, filter } = this.props;
    this.value = event.currentTarget.value;
    if (!filter || this.filterValue(this.value)){
      this.setState({ filteredValue: this.value });
      if (_.isFunction(onChange)) {
        onChange({
          inputElement: this.inputElement,
          value: this.value,
        });
      }
    }
  };

  onInputRef = (ref) => {
    this.inputElement = ref;
  };

  filterValue = (value) => this.state.filteredValue !== this.value &&
                          (/^\d+$/.test(value) || value === '') &&
                          value.length <= this.props.size;

  render() {
    const {
      isError,
      buttonCaption,
      onButtonClick,
      onInputClick,
      textType,
      align,
      placeholder,
      type,
      readOnly,
      fontSize,
      fontWeight,
      font,
    } = this.props;

    const { focused, filteredValue } = this.state;

    return (
      <DefaultInputStyled textType={textType} align={align}>
        <Wrapper focused={focused} isError={isError}>
          <StyledInput
            placeholder={placeholder}
            type={type}
            value={filteredValue}
            readOnly={readOnly}
            ref={this.onInputRef}
            onFocus={this.onFocusChange}
            onBlur={this.onFocusChange}
            onChange={this.onChange}
            onKeyUp={this.onChange}
            onPaste={this.onChange}
            onClick={onInputClick}
            fontSize={fontSize}
            font={font}
            fontWeight={fontWeight}
          />
          {buttonCaption && (
            <InputButtonStyled>
              <StyledButton
                text={buttonCaption}
                textFont="din_bold"
                textColor="blue_doger"
                hoverColor="blue_navyblue"
                tabIndex="-1"
                type="button"
                onClick={onButtonClick}
              />
            </InputButtonStyled>
          )}
        </Wrapper>
      </DefaultInputStyled>
    );
  }
}

DefaultInput.propTypes = {
  isError: PropTypes.bool,
  buttonCaption: PropTypes.string,
  filter: PropTypes.bool,
  size: PropTypes.number,
  onChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  onButtonClick: PropTypes.func,
  onInputClick: PropTypes.func,
  textType: PropTypes.string,
  align: PropTypes.string,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.oneOf([undefined]),
  ]),
  placeholder: PropTypes.string,
  type: PropTypes.string,
  readOnly: PropTypes.bool,
  fontSize: PropTypes.string,
  font: PropTypes.string,
  fontWeight: PropTypes.string,
};

DefaultInput.defaultProps = {
  isError: false,
  filter: false,
  buttonCaption: "",
  size: 4,
  onChange: Function.prototype,
  onFocusChange: Function.prototype,
  onButtonClick: Function.prototype,
  onInputClick: Function.prototype,
  textType: "",
  align: "left",
  defaultValue: '',
  placeholder: '',
  type: 'text',
  readOnly: false,
  fontSize: '',
  font: '',
  fontWeight: '',
};

export default DefaultInput;
